import { render, staticRenderFns } from "./PerfectUserMessage.vue?vue&type=template&id=53837f57&scoped=true"
import script from "./PerfectUserMessage.vue?vue&type=script&lang=js"
export * from "./PerfectUserMessage.vue?vue&type=script&lang=js"
import style0 from "./PerfectUserMessage.vue?vue&type=style&index=0&id=53837f57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53837f57",
  null
  
)

export default component.exports